<div mat-dialog-title="">
  <div class="flex justify-between content-center items-center flex-row flex-wrap gap-[1rem]">
    <h3 class="mat-h2 m0" translate="">Information</h3>
  </div>
</div>
<mat-dialog-content>
  <p>{{message}}</p>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-start content-center items-center flex-row gap-[1rem]">
  <button mat-button="" color="primary" [mat-dialog-close]="true" cdkFocusInitial=""><span translate="">Close</span></button>
</mat-dialog-actions>